import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaSearch, FaBell, FaPaperPlane } from "react-icons/fa";

const SearchIcon = FaSearch as React.ElementType;
const BellIcon = FaBell as React.ElementType;
const PaperPlaneIcon = (): JSX.Element =>
  React.createElement(FaPaperPlane as React.ElementType, {
    className: "su-icon-18 ml-2",
    "aria-hidden": true,
  });

const routeTitleMap: Record<string, string> = {
  "/": "Dashboard",
  "/insights": "Insights",
  "/email-updates": "Emails",
  "/workflows": "Workflows",
  "/debug": "Debug",
  "/profile": "Profile",
  "/integrations": "Integrations",
  "/contacts": "Contacts",
  "/settings": "Settings",
  "/updates/new": "Compose",
  "/updates/recipients": "Recipients",
  "/updates/schedule": "Schedule",
};

const NavBar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const title = useMemo(() => {
    const path = location.pathname;
    // First check for exact match (for specific routes like /updates/new)
    if (routeTitleMap[path]) {
      return routeTitleMap[path];
    }
    // Then match base route
    const base = "/" + path.split("/").filter(Boolean)[0] || "/";
    return routeTitleMap[base] || "Dashboard";
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 right-0 left-0 xl:left-[18.75rem] z-20 border-b border-white su-bg-n-2 text-white`}
    >
      <div className="flex items-center max-w-[90rem] mx-auto w-full h-18 px-16 2xl:px-8 lg:px-6 md:px-5">
        <div className="mr-4 text-2xl font-extrabold truncate md:mr-2">
          {title}
        </div>
        <div className="flex items-center shrink-0 ml-auto">
          <button
            className="text-white/80 hover:text-white p-2 mx-3"
            aria-label="Search"
          >
            <SearchIcon />
          </button>
          <button
            className="relative text-white/80 hover:text-white p-2 mx-3"
            aria-label="Notifications"
          >
            <BellIcon />
            <div className="absolute top-1.5 right-1 w-2 h-2 rounded-full bg-green-500"></div>
          </button>
          <button
            className="su-btn su-btn-purple su-btn-xl su-btn-square ml-3"
            onClick={() => navigate("/updates/new")}
          >
            <span className="inline-flex items-center">
              <span>Send Update</span>
              <PaperPlaneIcon />
            </span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default NavBar;
